import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { LeadRemarks } from '@core/models/lead-remarks.model';
import { ApiResponse } from '@core/models/api-response.model';
import { Pagination } from '@core/models/pagination.model';

@Injectable()
export class LeadRemarksDataService extends DefaultDataService<LeadRemarks> {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('LeadRemarks', http, httpUrlGenerator, { root: '' });
  }

  getWithQuery(pageParam: string): Observable<LeadRemarks[]>{
    return this.http.get<ApiResponse>(`/telemarketer/leadremarks${pageParam}`).pipe(
        tap(res => this.paginationInit(res)),
        map(res => res.data.rows)
    )
  }

  export(pageParam: string) {
    return this.http.get<ApiResponse>(`/telemarketer/exportleadremarks${pageParam}`).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }

}
